// 전화번호 포맷팅 함수
export const formatPhoneNumber = (phone: string | null | undefined) => {
  if (!phone) return null;

  // 숫자만 추출
  const numbers = phone.replace(/[^0-9]/g, "");

  // 길이에 따라 다르게 포맷팅
  if (numbers.length === 11) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
  } else if (numbers.length === 10) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
  }

  return phone; // 예상치 못한 형식이면 원본 반환
};
